import { User } from '@/Domain/api/User/dto/User.dto';

export type RoutingProfileFormValue = {
  user_id: number;
  routing_description: string;
  is_active: boolean;
};

export const buildRoutingProfiles = (
  savedProfiles: RoutingProfileFormValue[],
  users: User[] | undefined,
): RoutingProfileFormValue[] => {
  const normalizedSaved = savedProfiles.map(({ user_id, routing_description, is_active }) => ({
    user_id,
    routing_description,
    is_active,
  }));

  if (!users?.length) return normalizedSaved;

  const profilesByUserId = new Map(normalizedSaved.map((profile) => [profile.user_id, profile]));

  return users.map((user) => {
    const existing = profilesByUserId.get(user.id);
    return {
      user_id: user.id,
      routing_description: existing?.routing_description || '',
      is_active: existing?.is_active ?? false,
    };
  });
};
